import { defineMessages } from 'react-intl';

const _default_1: {
	sortAscending: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sortDescending: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	sortAscending: {
		id: 'atlassian-studio-ui-components.paginated-charlie-table.sortAscending',
		defaultMessage: 'Sort ascending',
		description: 'Label for ascending sort button',
	},
	sortDescending: {
		id: 'atlassian-studio-ui-components.paginated-charlie-table.sortDescending',
		defaultMessage: 'Sort descending',
		description: 'Label for descending sort button',
	},
});
export default _default_1;
